var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUmbrella = function SvgUmbrella(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36.156,
    height: 38.166,
    viewBox: "0 0 36.156 38.166",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "np_umbrella_2226433_000000",
    d: "M39.953,21.875A18.08,18.08,0,0,1,58.031,39.954a2.006,2.006,0,0,1-2.009,2.009H41.961v11.55a2.511,2.511,0,0,0,5.022,0,2.009,2.009,0,0,1,4.017,0,6.528,6.528,0,0,1-13.056,0V41.962H23.883a2.006,2.006,0,0,1-2.009-2.009A18.08,18.08,0,0,1,39.953,21.875Zm13.92,16.07a14.061,14.061,0,0,0-27.84,0Z",
    transform: "translate(-21.875 -21.875)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUmbrella, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/umbrella.9e65fc98.svg";
export { ForwardRef as ReactComponent };